import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { UpdateServiceVendorServiceRequest, ServiceVendorId, ServiceVendorServiceId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, toast, vendorServiceKeys } from '@petseo/shared';

interface UpdateServiceParams {
  serviceVendorId: ServiceVendorId;
  serviceVendorServiceId: ServiceVendorServiceId;
  data: UpdateServiceVendorServiceRequest;
}

export const useUpdateService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ serviceVendorId, serviceVendorServiceId, data }: UpdateServiceParams) => {
      const response = await serviceVendorsClient.putServiceVendorServiceEndpoint(data, String(serviceVendorId), String(serviceVendorServiceId));
      return response.data;
    },
    onSuccess: (_, { serviceVendorId }) => {
      queryClient.invalidateQueries({ queryKey: vendorServiceKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.SERVICE_UPDATED);
    },
    onError: () => toast.error(TOAST_MESSAGES.SERVICE_UPDATE_ERROR),
  });
};
